import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'document-plan-title-bar',
  templateUrl: './document-plan-title-bar.component.html',
  styleUrls: ['./document-plan-title-bar.component.scss'],
})
export class DocumentPlanTitleBarComponent implements OnInit {
  startDateFormatted: string;

  @Input() title: string;
  @Input() startDate: string;
  @Input() numWeeks: number;
  @Input() isOwner: boolean;
  @Input() isOnline: boolean;
  @Output() edited: EventEmitter<void> = new EventEmitter<void>();
  @Output() shared: EventEmitter<void> = new EventEmitter<void>();
  @Output() viewSwitched: EventEmitter<void> = new EventEmitter<void>();
  @Output() monthPrinted: EventEmitter<void> = new EventEmitter<void>();
  @Output() weekPrinted: EventEmitter<void> = new EventEmitter<void>();
  @Output() refreshed: EventEmitter<void> = new EventEmitter<void>();
  @Output() published: EventEmitter<void> = new EventEmitter<void>();
  @Output() copied: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {
    this.startDateFormatted = moment(this.startDate, 'MM/DD/YYYY').format('MMM D, YYYY');
  }

}
